import axios from 'axios';
import { message } from 'ant-design-vue';
import router from '../router';
import store from '../store';

const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 20000,
});


service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code === 2) {
      store.state.user.userId = null;
      router.push('/');
      message.error('登录超时,请重新登录');
    }
    return res;
  },
  (error) => { // 响应错误处理
    console.log('error');
    console.log(error);
    console.log(JSON.stringify(error));
    console.log(error.response.status);
    const errorCode = error.response.status;
    if (errorCode === 403) {
      console.log('没权限');
    } else {
      console.log('进入500错误了');
      message.error('发生未知错误');
      // router.push('/');
      // window.location.href = 'www.baidu.com';
    }
    // const text = JSON.parse(JSON.stringify(error)).response.status === 404
    //   ? '404'
    //   : '网络异常，请重试';
    // console.log(text);
  },
);

export default service;
